import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import TopHeader from "@/components/TopHeader";
import BottomPlayer from "@/components/BottomPlayer";
import MobileNav from "@/components/MobileNav";
import TopBanner from "@/components/TopBanner";
import AdBanner from "@/components/AdBanner";
import Footer from "@/components/Footer";

const Layout = () => {
  const location = useLocation();
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <TopHeader />
      {/* pb is responsive: mobile must clear BOTH the floating MobileNav
          (~60px @ bottom-[100px]) AND the BottomPlayer pill (~90px).
          Desktop only needs to clear the BottomPlayer. */}
      <main className="pb-[180px] md:pb-[120px] pt-6 px-4 sm:px-8 max-w-[1600px] mx-auto w-full">
        <TopBanner />
        {/* Cinematic page transitions — fade + lift on enter, fade + drop on
            exit. AnimatePresence with mode="wait" ensures the outgoing route
            finishes its exit before the new one mounts so we never have two
            stacked pages mid-animation. */}
        <AnimatePresence mode="wait" initial={false}>
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{
              duration: 0.32,
              ease: [0.22, 0.61, 0.36, 1],  // gentle ease-out (Apple's curve)
            }}
          >
            <Outlet />
          </motion.div>
        </AnimatePresence>
        <Footer />
      </main>
      <MobileNav />
      <AdBanner />
      <BottomPlayer />
    </div>
  );
};

export default Layout;
